module.exports = __webpack_public_path__ + "static/media/university-profile.aa7aa503.jpeg";